module.exports = __webpack_public_path__ + "img/ywfw.7e3aab34.png";